// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  stripeKey: 'pk_live_XUsvfpxh19ArNU8SGDlcRoJQ00aj7SaUSo',
  firebase: {
    apiKey: "AIzaSyCCvX4n4c5mbqnJKIbFkDwXiMwHbMryves",
    authDomain: "loyalhomes-d5cdc.firebaseapp.com",
    databaseURL: "https://loyalhomes-d5cdc.firebaseio.com",
    projectId: "loyalhomes-d5cdc",
    storageBucket: "loyalhomes-d5cdc.appspot.com",
    messagingSenderId: "992266913371",
    appId: "1:992266913371:web:24ee06248a752f7bd7e17e",
    measurementId: "G-GFYZN76WLW"
  },
  propertyDataKey: 'SYNWZLOHB4',
  googleMapsApiKey: 'AIzaSyBVvz1Goep4j6E0kKsH6zdYKGqulPF1eQI'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
